// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard{
    background-color: #fff;
    border-bottom: 1px solid #f0f5f8;
    height: 50px;
    margin-bottom: 12px;
    width: 100%;
    margin: 0px;
    padding: 0px;
 }
 .dashboard  span{
     margin-top: 6px;
     font-size: 23px;
 }
 .component a{
     text-decoration: none;
 }
 .overview a{
     text-decoration: none;
 }`, "",{"version":3,"sources":["webpack://./src/Sidebar/DashBoards.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,gCAAgC;IAChC,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,YAAY;CACf;CACA;KACI,eAAe;KACf,eAAe;CACnB;CACA;KACI,qBAAqB;CACzB;CACA;KACI,qBAAqB;CACzB","sourcesContent":[".dashboard{\r\n    background-color: #fff;\r\n    border-bottom: 1px solid #f0f5f8;\r\n    height: 50px;\r\n    margin-bottom: 12px;\r\n    width: 100%;\r\n    margin: 0px;\r\n    padding: 0px;\r\n }\r\n .dashboard  span{\r\n     margin-top: 6px;\r\n     font-size: 23px;\r\n }\r\n .component a{\r\n     text-decoration: none;\r\n }\r\n .overview a{\r\n     text-decoration: none;\r\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
